import FeatureSet from "../packaging/FeatureSet.js";
import Option from "./Option.js";

const settingToAttribute = {
	"report-templates-for-standard-reports":
		"reportTemplateForStandardReportsEnabled",
	"acknowledge-period-report": "acknowledgePeriodReportEnabled",
	"active-period": "activePeriodFeatureEnabled",
	"period-report-email-notification":
		"periodReportNotificationFeatureEnabled",
	"document-archive-notification":
		"documentArchiveNotificationFeatureEnabled",
	disclaimer: "reportDisclaimerEnabled",
	"lrfk-kpi": "lrfkFarmerKeyFiguresEnabled",
	"forecast-to-budget": "forecastToBudgetEnabled",
};

/**
 * The OptionsBag carries {@link Options}s
 */
export class OptionsBag {
	constructor() {
		this._features = new FeatureSet();
		this._agencySettings = {};
	}

	fromId(id) {
		const feature = this._features.getById(id);
		if (feature) {
			return new Option({ active: true });
		}

		const agencySettingKey = settingToAttribute[id];
		return new Option({ active: !!this._agencySettings[agencySettingKey] });
	}

	setFeatures(features) {
		this._features.addFeatures(features);
	}

	setAgencySettings(agencySettings) {
		this._agencySettings = agencySettings;
		this._agencySettings.reportTemplateForStandardReportsEnabled = true; // we mimic the monitor behavior
	}
}

const optionsBag = new OptionsBag();

export default optionsBag;
